<template>
  <div class="investor-filters">
    <el-form ref="form" label-position="top" :model="form" :rules="rules">
      <el-row class="margin-bottom-20" :gutter="gutter">
        <el-col :span="6">
          <el-form-item class="search-form-item" label="Search">
            <el-input
              v-model="form.search"
              prefix-icon="el-icon-search"
              class="search"
              placeholder="Search"
              clearable
              @input="emitChanges"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Type">
            <MultiSelect
              v-model="form.types"
              placeholder="Choose types"
              all-button
              :choices="investorTypeChoices"
              @change="emitChanges"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Investment regions">
            <MultiSelect
              v-model="form.regions"
              placeholder="Choose regions"
              filterable
              :choices="countriesChoices"
              @change="emitChanges"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item
            label="Investment value"
            prop="investment"
            class="investment-filter"
          >
            <el-input
              v-model.number="form.investment"
              placeholder="Investment value"
              clearable
              @input="emitChanges"
            >
              <span slot="prefix">€</span>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Company stage" prop="stage">
            <MultiSelect
              v-model="form.stages"
              placeholder="Choose stages"
              all-button
              :choices="companyStageChoices"
              @change="emitChanges"
            />
          </el-form-item>
        </el-col>

        <el-col v-if="false" :span="6">
          <el-form-item label="Product type" prop="productTypes">
            <MultiSelect
              v-model="form.productTypes"
              placeholder="Choose types"
              all-button
              :choices="productTypeChoices"
              @change="emitChanges"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Sectors">
            <MultiSelect
              v-model="form.sectors"
              placeholder="Choose sectors"
              all-button
              :choices="sectorChoices"
              @change="emitChanges"
            />
          </el-form-item>
        </el-col>

        <el-col v-if="false" :span="6">
          <el-form-item label="Business types">
            <MultiSelect
              v-model="form.businessTypes"
              all-button
              :choices="businessTypeChoices"
              @change="emitChanges"
            />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="Round stages">
            <MultiSelect
              v-model="form.roundStages"
              placeholder="Choose stages"
              all-button
              :choices="roundStageChoices"
              @change="emitChanges"
            />
          </el-form-item>
        </el-col>

        <el-col v-if="user.isAdmin" :span="6" :offset="18">
          <el-form-item class="actions" label="Add button">
            <el-button type="primary" @click="$emit('add-button-clicked')">
              Add investor
            </el-button>
          </el-form-item>
        </el-col>

        <el-col class="filters-extra" :span="24">
          <a class="filters-action-link" href @click.prevent="clearAll()">
            <i class="ion-android-close"></i>
            Clear all
          </a>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { investorTypeChoices } from 'services/investor-types'
import { COUNTRIES_CHOICES } from 'services/countries'
import { stagesChoices } from 'services/stages'
import { productTypeChoices } from 'services/product-types'
import { sectorChoices } from 'services/sectors'
import { businessTypeChoices } from 'services/business-types'
import { roundStageChoices } from 'services/round-stages'
import MultiSelect from 'components/MultiSelect.vue'
import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  components: { MultiSelect },
  computed: {
    filters() {
      return {
        search: this.form.search,
        type: this.form.types,
        invests_in: this.form.regions,
        investment: this.form.investment,
        stage: this.form.stages,
        product_type: this.form.productTypes,
        sector: this.form.sectors,
        business_type: this.form.businessTypes,
        round_stage: this.form.roundStages,
      }
    },
    ...mapState({
      user: (s) => s.user.data,
    }),
  },
  data() {
    return {
      form: initForm(),
      rules: {
        investment: [
          {
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (!value) {
                callback()
              }
              if (!_.isInteger(value)) {
                callback(new Error('Value must be a number'))
              }
              callback()
            },
          },
        ],
      },
      gutter: 20,
      investorTypeChoices: investorTypeChoices,
      countriesChoices: COUNTRIES_CHOICES,
      companyStageChoices: stagesChoices,
      productTypeChoices: productTypeChoices,
      sectorChoices: sectorChoices,
      businessTypeChoices: businessTypeChoices,
      roundStageChoices: roundStageChoices,
    }
  },
  methods: {
    async emitChanges() {
      const form = this.$refs.form
      try {
        await form.validate()
        this.$emit('change', this.filters)
      } catch (error) {
        // console.log(" => not valid", error);
      }
    },

    clearAll() {
      this.form = initForm()
      this.emitChanges()
    },
  },
}

function initForm() {
  return {
    search: '',
    types: [],
    regions: [],
    investment: null,
    stages: [],
    productTypes: [],
    sectors: [],
    businessTypes: [],
    roundStages: [],
  }
}
</script>

<style lang="scss">
.investor-filters {
  .el-form-item__label {
    line-height: 20px;
    padding: 0;
  }

  // do not show green border at filters
  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #dcdfe6;
  }

  .el-select,
  .el-button {
    width: 100%;
  }

  .actions,
  .search-form-item {
    .el-form-item__label {
      visibility: hidden;
    }
  }

  .investment-filter {
    .el-input__prefix {
      left: 15px;
    }
  }
}
</style>
